import { OBPSService } from "../../elements/OBPS";

const ApplicationUpdateActions = async (applicationData, tenantId,formType) => {
  try {
    if(["form11","form26","FORM_CLU","formCLU","FORM_NOC","formNOC","FORM_MT","formMT","form16","FORM_16"].includes(formType)){
      return await OBPSService.updateForm11(applicationData, tenantId);
    }
    if(["formLandUse","FORM_LANDUSE"].includes(formType)){
      return await OBPSService.updateFormLandUse(applicationData, tenantId);
    }
    const response = await OBPSService.update(applicationData, tenantId);
    return response;
  } catch (error) {
    throw new Error(error?.response?.data?.Errors[0].message);
  }
};

export default ApplicationUpdateActions;
